export const steps = [
  {
    title: "Registration",
  },
  {
    title: "Code Request",
  },
];

export const NOTIFICATION = {
  FORM_VALIDATION:
    "Your Form Contains Multiple Errors. Please Check Your Details.",
  LOADING: "Please wait while we are saving your data...",
  WAIT: "Please Wait ...",
  SUCCESS_REGISTER: "Customer Registered Successfully.",
  DUPLICATE_EMP_CODE:"Duplicate Employee Code Found"
};

export const MULTIVALUE_FIELD = {
  company_email: "company_email",
  company_contactno: "company_contactno",
  contact_person_details: "contact_person_details"
};

export const TYPE_OF_CUSTOMER = "type_of_customer";

export const CUSTOMER_GROUP = "AN13";

export const VALIDATE_FIELDS = {
  external_number_range: "external_number_range",
};

export const CLIENT_ID = "720";

export const title = {
  Error: "Error",
  Next: "Next",
  Previous: "Previous",
  Finish: "Finish",
  Clear: "Clear",
  Registration: "Registration",
  Code_Creation: "Code Creation",
  fme: "fme",
};

export const REG_VALIDATE_FIELDS = [
  "title",
  "customer_name",
  "address_line1",
  "address_line2",
  "address_line3",
  "country",
  "state",
  "city",
  "pincode"  
];

export const SCROLL_TO_FIELD_FOR_MULTIV = {
  contact_person_designation: "contact_person_designation",
  fme_name: "fme_name"
};

export const DEFAULT_FME_DATA = {
  company_code: 4,
};

export const CONTACT_PERSON_FIELDS = [
  "contact_person_title",
  "contact_person_last_name",
  "contact_person_first_name",
  "contact_person_designation",
  "contact_person_department",
  "contact_person_mobile_number",
  "contact_person_telephone_number",
  "contact_person_email"
];

export const Actions = {
  insert: "insert",
  update: "update",
  delete: "delete",
  status: "status",
  radio: "Radio"
};
